import type { GovernmentIntegration, GovernmentIntegrationEnablement } from './enablement-types';

export const GOVERNMENT_INTEGRATION_NOTICE_METADATA_KEY = 'government_integration' as const;

export type GovernmentIntegrationNoticeRow = { metadata?: unknown };

const GOVERNMENT_INTEGRATIONS = new Set<GovernmentIntegration>([
  'hi',
  'dhda_b2g',
  'services_australia',
]);

export function governmentIntegrationNoticeKey(metadata: unknown): GovernmentIntegration | null {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return null;
  const value = (metadata as Record<string, unknown>)[GOVERNMENT_INTEGRATION_NOTICE_METADATA_KEY];
  return typeof value === 'string' && GOVERNMENT_INTEGRATIONS.has(value as GovernmentIntegration)
    ? (value as GovernmentIntegration)
    : null;
}

export function hasGovernmentIntegrationNoticeMarker(metadata: unknown): boolean {
  return Boolean(
    metadata &&
    typeof metadata === 'object' &&
    !Array.isArray(metadata) &&
    Object.hasOwn(metadata, GOVERNMENT_INTEGRATION_NOTICE_METADATA_KEY),
  );
}

export function canViewGovernmentIntegrationNotice(
  metadata: unknown,
  role: string | null | undefined,
  enabled: GovernmentIntegrationEnablement,
): boolean {
  const integration = governmentIntegrationNoticeKey(metadata);
  if (!integration) return !hasGovernmentIntegrationNoticeMarker(metadata);
  return (role === 'OWNER' || role === 'TENANT_ADMIN') && enabled[integration] === true;
}

export function filterGovernmentIntegrationNotices<T extends { metadata?: unknown }>(
  rows: readonly T[],
  role: string | null | undefined,
  enabled: GovernmentIntegrationEnablement,
): T[] {
  return rows.filter((row) => canViewGovernmentIntegrationNotice(row.metadata, role, enabled));
}
